import { render, staticRenderFns } from "./FieldDataModal.vue?vue&type=template&id=436971e2&"
import script from "./FieldDataModal.vue?vue&type=script&lang=ts&"
export * from "./FieldDataModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports